import identity from 'lodash/identity'
import pickBy from 'lodash/pickBy'
import React, { Component } from 'react'

import PhoneInput from '~/components/phone-input'
import SelectInput from '~/components/select-input'
import TextInput from '~/components/text-input'
import { i18n } from '~/i18n'

import { Form } from './styles'

import type { ComponentType } from 'react'
import type { Fields } from '~/components/form/form.types'
import type { Props as PhoneInputProps } from '~/components/phone-input'
import type {
  Option,
  Props as SelectInputProps,
} from '~/components/select-input'
import type { Props as TextInputProps } from '~/components/text-input'
import type { Address as AddressType } from '~/types'

export type Props = {
  className?: string
  countriesAndStates: {
    countriesWithStates: Record<string, Array<string>>
    sortedCountryNames: Array<string>
  }
  address: AddressType
  errors: Record<string, any>
  onChange: (arg0: string, arg1: string) => void
  TextInputComponent?: ComponentType<TextInputProps>
  SelectInputComponent?: ComponentType<SelectInputProps>
  PhoneInputComponent?: ComponentType<PhoneInputProps>
}

export default class Address extends Component<Props> {
  static defaultProps = {
    TextInputComponent: TextInput,
    SelectInputComponent: SelectInput,
    PhoneInputComponent: PhoneInput,
  }

  onBlur = (field: string, value: any) => {
    if (typeof value === 'string') {
      this.props.onChange(field, value.trim())
    }
  }

  onChange = (field: string, value: any) => {
    if (typeof value === 'string') {
      this.props.onChange(field, value)
    }
  }

  stateOptions(): Option[] {
    const { address } = this.props
    const { country = this.props.countriesAndStates.sortedCountryNames[0] } =
      address
    const { countriesWithStates } = this.props.countriesAndStates
    return countriesWithStates[country] || []
  }

  formFields() {
    const { address } = this.props
    const fields: Fields = {
      street1: {
        type: 'text',
        id: `${address.type}-street`,
        name: 'street1',
        label: i18n.t('components.address_form.street1_label'),
      },
      country: {
        type: 'select',
        id: `${address.type}-country`,
        name: 'country',
        options: this.props.countriesAndStates.sortedCountryNames,
        label: i18n.t('components.address_form.country_label'),
      },
      city: {
        type: 'text',
        id: `${address.type}-city`,
        name: 'city',
        label: i18n.t('components.address_form.city_label'),
      },
      stateProvince: {
        type: 'select',
        id: `${address.type}-state`,
        name: 'stateProvince',
        options: this.stateOptions(),
        placeholder: i18n.t('components.address_form.state_default_prompt'),
        fieldClass: 'state-province',
        label: i18n.t('components.address_form.state_province_label'),
        key: address.country,
      },
      zipPostal: {
        type: 'text',
        id: `${address.type}-zip-code`,
        name: 'zipPostal',
        fieldClass: 'zip-postal',
        label: i18n.t('components.address_form.zip_postal_label'),
      },
    }

    return pickBy(fields, identity)
  }

  render() {
    const { TextInputComponent, PhoneInputComponent, SelectInputComponent } =
      this.props

    return (
      <Form
        data-testid="amp-address-form"
        className={this.props.className}
        object={this.props.address}
        errors={this.props.errors}
        fields={this.formFields()}
        onChange={this.onChange}
        onBlur={this.onBlur}
        TextInputComponent={TextInputComponent}
        PhoneInputComponent={PhoneInputComponent}
        SelectInputComponent={SelectInputComponent}
      />
    )
  }
}
